"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_MAP = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../icons");
var variables_1 = require("../../../style/variables");
var layout_1 = require("../../layout");
var RichTextEditorToolbarButton_1 = __importDefault(require("./RichTextEditorToolbarButton"));
exports.ACTION_MAP = {
    bold: {
        label: 'bold',
        type: icons_1.Bold,
        style: 'BOLD',
        buttonType: 'inline',
    },
    italic: {
        label: 'italic',
        type: icons_1.Italic,
        style: 'ITALIC',
        buttonType: 'inline',
    },
    'unordered-list': {
        label: 'ordered-list-item',
        type: icons_1.List,
        style: 'ordered-list-item',
        buttonType: 'block',
    },
    'ordered-list': {
        label: 'unordered-list-item',
        type: icons_1.List,
        style: 'unordered-list-item',
        buttonType: 'block',
    },
};
var DEFAULT_ACTIONS = Object.keys(exports.ACTION_MAP);
var RichTextEditorToolbar = function (_a) {
    var _b = _a.actions, actions = _b === void 0 ? DEFAULT_ACTIONS : _b, editorState = _a.editorState, onEditorStateChanged = _a.onEditorStateChanged, disabled = _a.disabled;
    var currentStyle = editorState.getCurrentInlineStyle();
    var selection = editorState.getSelection();
    var blockType = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();
    return (react_1.jsx(layout_1.Flex, { css: {
            borderBottom: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
            width: '100%',
            padding: '12px 16px',
        }, justifyContent: "flex-start", alignItems: "center" }, actions &&
        actions.map(function (action) { return (react_1.jsx(RichTextEditorToolbarButton_1.default, { key: exports.ACTION_MAP[action].label, icon: exports.ACTION_MAP[action].type, style: exports.ACTION_MAP[action].style, selected: exports.ACTION_MAP[action].buttonType === 'block'
                ? exports.ACTION_MAP[action].style === blockType
                : currentStyle.has(exports.ACTION_MAP[action].style), onClick: onEditorStateChanged, buttonType: exports.ACTION_MAP[action].buttonType, disabled: disabled })); })));
};
exports.default = RichTextEditorToolbar;
